import React, { useState, useEffect, useNavigate, useRef } from "react";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import Calender from "../../assets/icons/Calendar with interaction.svg";
import Expand from "../../assets/icons/Expand.svg";
import Print from "../../assets/icons/Print_icon.svg";
import Group from "../../assets/icons/Group_3100.svg";
import ArrowIcon from "../../assets/icons/arrowdown.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import "../../assets/styles/local/Report.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import userImg from "../../assets/images/user1.png";
import clock from "../../assets/images/clock-hover.svg";
import clockNoHover from "../../assets/images/clock.svg";
import Checkbox from "@mui/material/Checkbox";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import edit from "../../assets/icons/edit-2.svg";
import Pagination from "../../components/Pagination/Pagination";
import trash from "../../assets/icons/DeleteIcon.svg";
import { getWorktimeReport } from "../../redux/actions/worktimeActions";
import { Spinner } from "react-bootstrap";
import { generateCSV } from "../../utils/helpers/csvService";
import { convertToPDF } from "../../utils/helpers/pdfService";
import lock from "../../assets/images/lock.svg";
import { convertToExcel } from "../../utils/helpers/excelService";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { approveWorktimeReport } from "../../redux/actions/worktimeActions";
import { DeleteManualTimeSession } from "../../redux/actions/worktimeActions";
import { ROLES, isRole } from "../../utils/helpers/userRole";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import { useDispatch, useSelector } from "react-redux";
import Calendar2 from "../../assets/icons/Calendar3.svg";
import Clock from "../../assets/icons/Path 598.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import searchicon from "../../assets/icons/search.svg";
import Cross from "../../assets/icons/x-circle-2.svg";
import { Modal } from "react-bootstrap";
import Loader from "../../components/Dailogs/Loader";
import {
  CheckExistingTimeSession,
  CreateManualTimeSession,
  FetchProject,
  UpdateManualTimeSession,
  fetchTaskByProject,
  FetchTasksWithOutProject,
} from "../../redux/actions/action";
import { usePDF } from "react-to-pdf";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

export default function Report() {
  moment.updateLocale("en", {
    week: {
      dow: 1,
    },
  });

  const history = useHistory();
  const screenSize = useScreenSize();
  const [date, setDate] = useState(new Date());

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Worktime-Report").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [expandedRows, setExpandedRows] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [innerRow, setInnerRow] = useState([]);
  const [filter, setFilter] = useState("all");
  const [checkboxClicked, setCheckboxClicked] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedOption, setSelectedOption] = useState("Report");
  const [query, setQuery] = useState("");
  const [filteredReport, setFilteredReport] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [initialSD, setInitialSD] = useState(null);
  const [initialED, setInitialED] = useState(null);
  const [week, setWeek] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [selectedView, setSelectedView] = useState("WEEKLY");
  const [openView, setOpenView] = useState(false);

  // for pdf print download start.
  let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
  // let selectedProject = localStorage.getItem("projectForPrint");
  // let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
  // let selectedClientName = localStorage.getItem("clientNameForPrint");
  let employeeName = localStorage.getItem("firstname");

  let pdfTitle = `${employeeName}-Worktime Report,-${workspaceName}-${moment(
    new Date(),
  ).format("YYYY.MM.DD, h:mm a")}.pdf`;
  // for pdf print download end.

  const { toPDF, targetRef } = usePDF({ filename: pdfTitle });

  const fetchTaskWithoutProjectRes = useSelector(
    (state) => state?.user?.fetchTaskWithoutProjectRes,
  );

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (option === "Tracking") {
      history.push("/tracking");
    }
  };

  const datePickerFunc = (val) => {
    if (val != undefined) {
      setDate(val);
      getRange(val, selectedView);
      setCalendarIsOpen(!calendarIsOpen);
    }
  };

  const handleExpandButtonClick = () => {
    setExpandedRows((prevExpandedRows) => {
      // If no accordion is expanded, expand all
      if (prevExpandedRows.length === 0) {
        return Array.from({ length: report.length }, (_, i) => i);
      } else {
        // If any accordion is expanded, collapse all
        return [];
      }
    });
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    if (panel === "expandAll") {
      setExpanded(isExpanded);
    } else {
      setExpandedRows(
        isExpanded
          ? [...expandedRows, panel]
          : expandedRows.filter((row) => row !== panel),
      );
    }
  };

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);

  const [startDate, setStartDate] = useState(
    moment().startOf("isoWeek").format(),
  );
  const [endDate, setEndDate] = useState(moment().endOf("isoWeek").format());

  const getRange = (selectedDate, view) => {
    const currentDate = selectedDate || new Date();
    const currentDay = currentDate.getDay();

    const startDate = new Date(currentDate);

    // startDate.setDate(
    //   currentDate.getDate() - currentDay + (currentDay === 0 ? -6 : 1)
    // );
    const endDate = new Date(currentDate);
    if (view === "WEEKLY") endDate.setDate(startDate.getDate() + 6);
    const startDateString = moment(startDate)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");
    const endDateString =
      view === "MONTHLY"
        ? moment(endDate)
            .endOf("month")
            .startOf("day")
            .format("YYYY-MM-DDTHH:mm:ss")
        : // ? moment(endDate).add(1, "M").startOf("day").format("YYYY-MM-DDTHH:mm:ss")
          moment(endDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    setStartDate(startDateString);
    setEndDate(endDateString);
    fetchData(startDateString, endDateString);
  };

  const getInitialRange = (selectedDate) => {
    const currentDate = selectedDate || new Date();
    const currentDay = currentDate.getDay();

    const startDate = new Date(currentDate);

    // startDate.setDate(
    //   currentDate.getDate() - currentDay + (currentDay === 0 ? -6 : 1)
    // );
    const endDate = new Date(currentDate);
    endDate.setDate(startDate.getDate() + 6);
    const startDateString = moment(startDate)
      .startOf("day")
      .format("DD-MM-YYYY");
    const endDateString = moment(endDate).startOf("day").format("DD-MM-YYYY");
    setInitialSD(startDateString);
    setInitialED(endDateString);
  };

  const getCurrentWeekOfYear = () => {
    const currentDate = new Date();
    const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
    const differenceInMilliseconds = currentDate - startOfYear;
    const weekOfYear = Math.ceil(
      differenceInMilliseconds / (7 * 24 * 60 * 60 * 1000),
    );

    setWeek(moment(date).week());
  };

  const handleRowClick = (projectId, rowId) => {
    if (!checkboxClicked.includes(rowId)) {
      setInnerRow((prevExpandedRows) =>
        prevExpandedRows.includes(projectId)
          ? prevExpandedRows.filter((id) => id !== projectId)
          : [...prevExpandedRows, projectId],
      );
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);

    getInitialRange(date);
    getCurrentWeekOfYear();
    if (isRole(ROLES.MANAGER) || isRole(ROLES.OWNER)) {
      fetchData(null, null);
    } else {
      history.push("/tracking");
    }
  }, []);

  const fetchData = async (sd, nd) => {
    try {
      const pageNo = 1;

      const result = await getWorktimeReport(pageNo, itemsPerPage, sd, nd);
      setReport(result);
      setFilteredReport(result);
      // Calculate total pages and update the state
      if (result && result.length > 0) {
        setTotalPages(Math.ceil(result.length / itemsPerPage));
      } else {
        setTotalPages(0); // Handle the case when the result is empty
      }

      const updatedCheckboxClicked = result
        .map((user) => {
          const allApproved = user.dateWiseTasksList.every((task) =>
            task.every((t) => t.isApproved),
          );
          return allApproved ? user.userId : null;
        })
        .filter((userId) => userId !== null);

      setCheckboxClicked(updatedCheckboxClicked);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleAll = () => {
    setFilter("all");
    filteredData("all");
  };

  const handleApproved = () => {
    setFilter("approved");
    filteredData("approved");
  };

  const handleUnapproved = () => {
    setFilter("unapproved");
    filteredData("unapproved");
  };

  const filteredData = (filter) => {
    if (filter === "all") {
      setFilteredReport(report);
    } else if (filter === "approved") {
      setFilteredReport(
        report.filter((item) => checkboxClicked.includes(item.userId)),
      );
    } else if (filter === "unapproved") {
      setFilteredReport(
        report.filter((item) => !checkboxClicked.includes(item.userId)),
      );
    }
    return [];
  };

  const handleCheck = async (rowId) => {
    const result = await approveWorktimeReport(rowId);
    setCheckboxClicked(
      checkboxClicked.includes(rowId)
        ? checkboxClicked.filter((id) => id !== rowId)
        : [...checkboxClicked, rowId],
    );
  };

  const handleItemsPerPageChange = (event) => {
    const selectedValue = event.target.value;
    setItemsPerPage(selectedValue);
    fetchData();
  };

  const getTotalWorkHrs = (utl) => {
    // Convert all decimal hours → minutes, then sum
    let totalMinutes = utl.reduce((sum, element) => {
      return sum + Math.round(element.totalHours * 60);
    }, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  // asc function👇
  const getHours = (hrs) => {
    const totalMinutes = Math.round(hrs * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  const handleViewChange = (view) => {
    setSelectedView(view);
    setOpenView(false);
    getRange(new Date(startDate), view);
  };

  const handlePrintAll = async (selectedFormat) => {
    switch (selectedFormat) {
      case "pdf":
        handleDownloadPDF();
        break;
      case "csv":
        handleDownloadCSV();
        break;
      case "xlsx":
        handleDownloadExcel();
        break;
      default:
        alert("Unsupported file format");
    }
  };

  const handleSinglePrint = async (report, format) => {
    const reportList = [{ ...report }];

    // let ASCexcelData = [{ ...report }];
    // delete ASCexcelData[0].dateWiseTasksList; // Remove dateWiseTasksList.

    let storedData = [{ ...report }];
    let ASCexcelData = storedData[0].dateWiseTasksList;
    console.log("asc456", ASCexcelData);

    switch (format) {
      case "pdf":
        convertToPDF(reportList);
        break;
      case "csv":
        generateCSV(reportList);
        break;
      case "xlsx":
        // convertToExcel(reportList);
        convertToExcel(reportList, "worktime-underData", ASCexcelData);
        break;
      default:
        alert("Unsupported file format");
    }
  };

  const handleDownloadCSV = () => {
    generateCSV(report);
  };

  const handleDownloadExcel = () => {
    let ASCexcelData = [];
    filteredReport
      ?.slice(currentPage * perPage, (currentPage + 1) * perPage)
      .map((report, index) => {
        console.log("asc22", report);
        return ASCexcelData.push({
          firstName: report.firstName,
          lastName: report.lastName,
          weekStart: report.weekStartDate,
          weekEnd: report.weekEndDate,
          weekNumber: report.weekNo + 1,
          totalHours: getTotalHours(report),
          totalWage: `&euro; ${getTotalWage(report)}`,
          isApproved: checkboxClicked.includes(report.userId),
          diffrence: getDifference(report),
        });
      });
    convertToExcel(report, "worktime5", ASCexcelData);
  };

  const handleDownloadPDF = () => {
    convertToPDF(report);
  };

  const handleApproveAll = () => {
    report.forEach((user) => {
      approveWorktimeReport(user.userId);
    });
    const extractedUserIds = report.map((obj) => obj.userId);
    setCheckboxClicked(extractedUserIds);
  };

  const getTotalHours = (data) => {
    let totalMinutes = 0;

    data.dateWiseTasksList.forEach((el) => {
      el.forEach((a) => {
        totalMinutes += Math.round(a.totalHours * 60);
      });
    });

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const totalString = `${hours}:${minutes.toString().padStart(2, "0")}`;

    return totalString;
  };

  const getTotalWage = (data) => {
    let total = 0;
    data.dateWiseTasksList.forEach((el) => {
      el.forEach((a) => {
        total = total + a.totalHours;
      });
    });
    const roundedTotal = parseFloat(total.toFixed(2));
    const totalWage = roundedTotal * data.wage;
    const roundedWage = parseFloat(totalWage.toFixed(2));
    return roundedWage;
  };

  const getDifference = (data) => {
    let totalHours = 0;

    data.dateWiseTasksList.forEach((el) => {
      el.forEach((a) => {
        totalHours += a.totalHours;
      });
    });

    const roundedTotalHours = parseFloat(totalHours.toFixed(2));

    const differenceHours = roundedTotalHours - data.weekHrs;

    const hours = Math.floor(Math.abs(differenceHours));
    const rawMinutes = (Math.abs(differenceHours) * 60) % 60;

    const roundedMinutes = parseFloat(rawMinutes.toFixed(2));

    const minutes = Math.floor(roundedMinutes);

    const sign = differenceHours >= 0 ? "+" : "-";
    const totalString = `${sign}${hours}:${minutes
      .toString()
      .padStart(2, "0")}`;

    return totalString;
  };

  const deleteTask = (project) => {
    DeleteManualTimeSession(project);
    const filteredData = report.map((user) => ({
      ...user,
      dateWiseTasksList: user.dateWiseTasksList.map((tasks) =>
        tasks.filter(
          (task) =>
            task.projectTaskTrackingTimeid !==
            project.projectTaskTrackingTimeid,
        ),
      ),
    }));
    setFilteredReport(filteredData);
    setReport(filteredData);
  };

  const [showEditModalData, setShowEditModalData] = useState({
    projectTaskTrackingTimeid: "",
  });
  const handleCancelModal = () => {
    // setShowModal(false);
    setShowEditModalData({ projectTaskTrackingTimeid: "" });
    fetchData(startDate, endDate);
  };

  const [userIDToAdd, setUserIDToAdd] = useState("");
  const handleAddTime = (userId) => {
    setShowModal(true);
    setUserIDToAdd(userId);
  };

  const [taskToEdit, setTaskToEdit] = useState("");
  const editTask = (task, userId) => {
    setUserIDToAdd(userId);
    setTaskToEdit(task.projectTaskTrackingTimeid);
    setShowEditModalData({
      projectTaskTrackingTimeid: task.projectTaskTrackingTimeid,
      projectname: task?.projectName,
      taskname: task?.taskName,
      type: task?.type,
      description: task?.description,
      totalHours: task?.totalHours,
      trackerEndTime: task?.trackerEndTime,
      trackerStartDate: task?.trackerStartDate,
      trackerStartTime: task?.trackerStartTime,
    });
    setShowModal(true);
  };

  function getDayInitials(dateString) {
    // const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const daysOfWeek = [
      t("Sun"),
      t("Mon"),
      t("Tue"),
      t("Wed"),
      t("Thu"),
      t("Fri"),
      t("Sat"),
    ];

    const date = new Date(dateString);
    const dayIndex = date.getDay();

    if (dayIndex >= 0 && dayIndex < daysOfWeek.length) {
      return daysOfWeek[dayIndex];
    }

    return "";
  }

  // asc cancel popup start //
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    setCancelPopupShow(false);
    setShowModal(false);
    setTypeInScreen("");
  };
  const [typeInScreen, setTypeInScreen] = useState("");
  // asc cancel popup end //

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  const [miniBoxOpen, setMiniBoxOpen] = useState(null);
  const [arrowOpen, setArrowOpen] = useState(null);
  const [printAllShow, setPrintAllShow] = useState(false);

  return (
    <>
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div>
          <Header
            setQuery={setQuery}
            leftComponent={
              <div className="flex-wrap gap-5 d-flex align-items-baseline">
                <div
                  className="projectText2"
                  onClick={() => {
                    history.push("/worktime");
                  }}
                >
                  {/* Worktime */}
                  {t("Worktime")}
                </div>
                <div
                  className="projectText4"
                  id="forWorkTime"
                  style={{
                    background: "white",
                    padding: "5px",
                    border: "0.5px solid #e0dada",
                    borderRadius: "8px",
                  }}
                >
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      border: "none",
                      boxShadow: "none",
                      color: "#212529",
                    }}
                  >
                    {selectedOption}
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                    // style={{ top: "9px", left: "-6px" }}
                    style={{ inset: "7px auto auto -7px" }}
                  >
                    <li>
                      <a
                        className={`dropdown-item ${
                          selectedOption === "Report" ? "active" : ""
                        }`}
                        href="#"
                        onClick={() => handleOptionClick("Report")}
                      >
                        {/* Report */}
                        {t("Report")}
                      </a>
                    </li>
                    <li>
                      <a
                        className={`dropdown-item ${
                          selectedOption === "Tracking" ? "active" : ""
                        }`}
                        href="#"
                        onClick={() => handleOptionClick("Tracking")}
                      >
                        {/* Tracking */}
                        {t("Tracking")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            }
          />

          {cancelPopupShow && (
            <CancelWarningModal
              show={cancelPopupShow}
              // onHide={() => setCancelPopupShow(false)}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              handleCancel={handleCancel}
            />
          )}

          <div
            className="worktime-main-div"
            style={{ minWidth: screenSize === "xs" && "auto" }}
          >
            <div className="d-flex flex-wrap gap-1 d-block d-sm-none">
              <div
                className="projectText2"
                onClick={() => {
                  history.push("/project");
                }}
              >
                {/* Worktime */}
                {t("Worktime")}
              </div>
              <div
                className="projectText4"
                style={{
                  background: "white",
                  padding: "5px",
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                }}
              >
                <button
                  className="btn dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedOption}
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedOption === "Report" ? "active" : ""
                      }`}
                      href="#"
                      onClick={() => handleOptionClick("Report")}
                    >
                      {/* Report */}
                      {t("Report")}
                    </a>
                  </li>
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedOption === "Tracking" ? "active" : ""
                      }`}
                      href="#"
                      onClick={() => handleOptionClick("Tracking")}
                    >
                      {/* Tracking */}
                      {t("Tracking")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className={screenSize === "xs" ? "sortingTabMob" : "sortingTab"}
              style={{ cursor: "pointer" }}
            >
              <div
                className="sortby-div"
                onClick={() => handleAll()}
                style={{
                  backgroundColor: filter === "all" ? "#95A7C6" : "initial",
                  borderRadius: filter === "all" ? "6px" : "",
                  color: filter === "all" ? "white" : "initial",
                }}
              >
                {/* All */}
                {t("All")}
              </div>
              <div
                className="sortby-div"
                onClick={() => handleApproved()}
                style={{
                  backgroundColor:
                    filter === "approved" ? "#95A7C6" : "initial",
                  borderRadius: filter === "approved" ? "6px" : "",
                  color: filter === "approved" ? "white" : "initial",
                }}
              >
                {/* Approved */}
                {t("Approved")}
              </div>
              <div
                className="sortby-div"
                onClick={() => handleUnapproved()}
                style={{
                  backgroundColor:
                    filter === "unapproved" ? "#95A7C6" : "initial",
                  borderRadius: filter === "unapproved" ? "6px" : "",
                  color: filter === "unapproved" ? "white" : "initial",
                }}
              >
                {/* Unapproved */}
                {t("Unapproved")}
              </div>
            </div>
            {screenSize !== "xs" && (
              <>
                <div className="worktime-nav-main-div">
                  <div className="worktime-nav-tab">
                    <h6 style={{ margin: "0", fontSize: "14px" }}>
                      {/* {report.length == 0
                        ? initialSD
                        : report[0]?.weekStartDate}{" "}
                      |{" "}
                      {report.length == 0 ? initialED : report[0]?.weekEndDate} */}
                      {report.length == 0
                        ? moment(startDate).format("DD-MM-YYYY")
                        : report[0]?.weekStartDate}{" "}
                      |{" "}
                      {report.length == 0
                        ? moment(endDate).format("DD-MM-YYYY")
                        : report[0]?.weekEndDate}
                    </h6>
                    <div>
                      <label
                        id="report_calender_DNone"
                        style={{
                          display: "flex",
                          width: "94%",
                        }}
                      >
                        <img
                          style={{ cursor: "" }}
                          src={Calender}
                          alt=""
                          onClick={(e) => {
                            e.preventDefault();
                            setCalendarIsOpen(!calendarIsOpen);
                          }}
                        />
                        <AppDatePicker
                          open={calendarIsOpen}
                          onOpenChange={(open) => setCalendarIsOpen(open)}
                          selected={date}
                          onChange={(val) => {
                            datePickerFunc(val);
                            setCalendarIsOpen(false);
                            setWeek(moment(date).week());
                          }}
                          onSelect={(d, event) => event.preventDefault()}
                          dateFormat="dd/MM/yyyy"
                          className={"ps-3"}
                        />
                      </label>
                    </div>
                    <h3
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        margin: "0",
                      }}
                    >
                      {/* WEEK {moment(date).week()} */}
                      {t("WEEK ")}
                      {moment(date).week()}
                      {/* WEEK {report.length == 0 ? week : report[0]?.weekNo} */}
                    </h3>
                  </div>
                  <div className="nav-option-div">
                    <div className="work-view-by-main-div">
                      <div
                        className="work-view-by-div"
                        onClick={() => setOpenView(!openView)}
                      >
                        <p>{selectedView?.toLowerCase()}</p>
                        <img
                          src={Downarrow}
                          style={{
                            width: "13px",
                            height: "13px",
                            transform: openView && "rotate(180deg)",
                          }}
                        />
                      </div>
                      {openView && (
                        <div className="work-view-by-list-div">
                          <p
                            className="work-view-by-single-item"
                            style={{
                              backgroundColor:
                                selectedView === "MONTHLY" &&
                                "rgb(250,250,250)",
                            }}
                            onClick={() => handleViewChange("MONTHLY")}
                          >
                            {/* Monthly */}
                            {t("Monthly")}
                          </p>
                          <p
                            className="work-view-by-single-item"
                            style={{
                              backgroundColor:
                                selectedView === "WEEKLY" && "rgb(250,250,250)",
                            }}
                            onClick={() => handleViewChange("WEEKLY")}
                          >
                            {/* Weekly */}
                            {t("Weekly")}
                          </p>
                        </div>
                      )}
                    </div>
                    <div
                      style={{ cursor: "pointer", padding: "10px" }}
                      onClick={handleExpandButtonClick}
                    >
                      <img src={Expand} style={{ padding: "0 10px" }} />
                      {/* Expand */}
                      {t("Expand")}
                    </div>
                    <div style={{ position: "relative" }}>
                      <div className="dropdown">
                        <div
                          style={{ cursor: "pointer" }}
                          type="button"
                          id="dropdownMenuButton1"
                          // data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={() => {
                            setPrintAllShow(!printAllShow);
                          }}
                        >
                          <img
                            src={Print}
                            style={{ padding: "0 10px" }}
                            alt="Print Icon"
                          />
                          {/* Print All */}
                          {t("print All")}
                        </div>
                      </div>
                      {printAllShow && (
                        <div
                          className="printAllUnderDiv"
                          aria-labelledby="dropdownMenuButton1"
                          style={{
                            height: printAllShow ? "85px" : "1px",
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "white",
                            cursor: "pointer",
                            width: "100%",
                            zIndex: 1,
                          }}
                        >
                          <p className="mb-1 work-print-single-item">
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                return toPDF();
                                handlePrintAll("pdf");
                              }}
                            >
                              {/* Download as PDF */}
                              {t("Download as PDF")}
                            </a>
                          </p>

                          <p className="mb-1 work-print-single-item">
                            <a
                              className="dropdown-item"
                              onClick={() => handlePrintAll("xlsx")}
                            >
                              {/* Download as Excel */}
                              {t("Download as Excel")}
                            </a>
                          </p>

                          <p className="mb-1 work-print-single-item">
                            <a
                              className="dropdown-item"
                              onClick={() => handlePrintAll("csv")}
                            >
                              {/* Download as CSV */}
                              {t("Download as CSV")}
                            </a>
                          </p>
                        </div>
                      )}
                    </div>

                    <div
                      style={{ cursor: "pointer", padding: "10px" }}
                      onClick={handleApproveAll}
                    >
                      <img src={Group} style={{ padding: "0 10px" }} />
                      {/* Approve All */}
                      {t("Approve All")}
                    </div>
                  </div>
                </div>

                <div className="worktime-table-div" ref={targetRef}>
                  {filteredReport
                    ?.slice(currentPage * perPage, (currentPage + 1) * perPage)
                    .map((report, index) => (
                      <Accordion
                        key={index}
                        expanded={expandedRows.includes(index) || expanded}
                        onChange={handleAccordionChange(index)}
                        className="customAccordionSummary"
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <div className="accordian-outer-div">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                width: "12rem",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                src={
                                  report.imageUrl == ""
                                    ? userImg
                                    : report.imageUrl
                                }
                                height={"31px"}
                                style={{ borderRadius: "50px" }}
                              />
                              <h6
                                style={{
                                  fontWeight: "bold",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              >
                                {report.firstName} {report.lastName}
                              </h6>
                            </div>
                            <h6 style={{ color: "#7E7E7E", width: "5rem" }}>
                              {report.weekHrs}H
                            </h6>
                            <h6 style={{ fontWeight: "bold" }}>
                              {/* WEEK  */}
                              {t("WEEK ")}
                              {report.weekNo + 1}
                            </h6>
                            <h6 style={{ color: "#7E7E7E" }}>Totals</h6>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <img src={clock} />
                              <h6 style={{ fontWeight: "bold" }}>
                                {getTotalHours(report)}
                              </h6>
                            </div>
                            <h6
                              style={{
                                fontWeight: "bold",
                                width: "5rem",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                              }}
                            >
                              &euro; {getTotalWage(report)}
                            </h6>
                            <h6 style={{ fontWeight: "bold" }}>
                              {getDifference(report)}
                            </h6>
                            <h6
                              style={{ color: "#7E7E7E" }}
                              onClick={(event) => event.stopPropagation()}
                            >
                              {/* Approve */}
                              {t("Approved")}
                              <Checkbox
                                {...label}
                                checked={checkboxClicked.includes(
                                  report.userId,
                                )}
                                icon={<CircleOutlinedIcon fontSize="small" />}
                                checkedIcon={<CircleIcon fontSize="small" />}
                                onChange={(event) => {
                                  event.stopPropagation();
                                  handleCheck(report.userId);
                                }}
                                onClick={(event) => event.stopPropagation()}
                              />
                            </h6>
                            <div
                              className="dropdown"
                              style={{ zIndex: "unset" }}
                            >
                              <div
                                style={{ cursor: "pointer" }}
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  alt=""
                                  src={Print}
                                  // onClick={(event) => event.stopPropagation()}
                                  onChange={handleAccordionChange(index)}
                                />
                              </div>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    className="dropdown-item"
                                    onClick={() => {
                                      handleSinglePrint(report, "pdf");
                                      localStorage.setItem(
                                        "clientNameForPrint",
                                        `${report.firstName ?? ""} ${report.lastName ?? ""}`,
                                      );
                                    }}
                                  >
                                    {/* Download as PDF */}
                                    {t("Download as PDF")}
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleSinglePrint(report, "xlsx")
                                    }
                                  >
                                    {/* Download as Excel */}
                                    {t("Download as Excel")}
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleSinglePrint(report, "csv")
                                    }
                                  >
                                    {/* Download as CSV */}
                                    {t("Download as CSV")}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <table className="your-table-styles">
                            <thead>
                              <tr className="accordian-summary-heading-div">
                                <th>
                                  {/* Day */}
                                  {t("Day")}
                                </th>
                                <th>
                                  {/* Type */}
                                  {t("Type")}
                                </th>
                                <th>
                                  {/* Project */}
                                  {t("Project")}
                                </th>
                                <th>
                                  {/* Section */}
                                  {t("Section")}
                                </th>
                                <th>
                                  {/* Time */}
                                  {t("Time")}
                                </th>
                                <th style={{ width: "35rem" }}>
                                  {/* Task Description */}
                                  {t("Task Description")}
                                </th>
                                <th
                                  style={{ width: "10rem", color: "#00246A" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img src={clockNoHover} alt="Clock Icon" />
                                    <h6
                                      style={{
                                        fontSize: "14px",
                                        color: checkboxClicked.includes(
                                          report.userId,
                                        )
                                          ? "grey"
                                          : "black",
                                        margin: "0",
                                        cursor: checkboxClicked.includes(
                                          report.userId,
                                        )
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                      onClick={() => {
                                        if (
                                          !checkboxClicked.includes(
                                            report.userId,
                                          )
                                        ) {
                                          handleAddTime(report.userId);
                                        }
                                      }}
                                    >
                                      {/* Add Time */}
                                      {t("Add Time")}
                                    </h6>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {report?.dateWiseTasksList
                                ?.sort(
                                  (a, b) =>
                                    new Date(a[0]?.trackerStartDate) -
                                    new Date(b[0]?.trackerStartDate),
                                )
                                .map((row, index) => (
                                  <React.Fragment key={index}>
                                    <tr
                                      onClick={() =>
                                        handleRowClick(
                                          row[0]?.trackerStartDate,
                                          report?.userId,
                                        )
                                      }
                                      className={
                                        innerRow.includes(
                                          row[0]?.trackerStartDate,
                                        )
                                          ? "expanded-row"
                                          : "table-row-data-div"
                                      }
                                    >
                                      <td>
                                        {getDayInitials(
                                          row[0]?.trackerStartDate,
                                        )}{" "}
                                        {row[0]?.trackerStartDate}
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td style={{ fontWeight: "bold" }}>
                                        {getTotalWorkHrs(row)}
                                      </td>
                                      <td
                                        style={{
                                          maxWidth: "100px",
                                          textWrap: "wrap",
                                          wordWrap: "break-word",
                                        }}
                                      ></td>
                                      <td>
                                        {checkboxClicked.includes(
                                          report?.userId,
                                        ) && <img src={lock} alt="locked" />}
                                      </td>
                                    </tr>
                                    {innerRow.includes(
                                      row[0]?.trackerStartDate,
                                    ) &&
                                      row
                                        ?.filter(
                                          (item) =>
                                            item.type
                                              ?.toLowerCase()
                                              .includes(query) ||
                                            item.projectName
                                              ?.toLowerCase()
                                              .includes(query) ||
                                            item.taskName
                                              ?.toLowerCase()
                                              .includes(query),
                                        )
                                        .map((r) => (
                                          <>
                                            <tr className="expanded-content-row">
                                              <td
                                                style={{ border: "none" }}
                                              ></td>
                                              <td>{r?.type}</td>
                                              <td>{r?.projectName}</td>
                                              <td
                                                className="pointer"
                                                onClick={() => {
                                                  history.push(
                                                    `/planboard/task/${r?.taskId}`,
                                                  );
                                                }}
                                              >
                                                {r?.taskName}
                                              </td>
                                              <td
                                                style={{ fontWeight: "bold" }}
                                              >
                                                {getHours(r?.totalHours)}
                                              </td>
                                              <td
                                                style={{
                                                  maxWidth: "100px",
                                                  textWrap: "wrap",
                                                  wordWrap: "break-word",
                                                }}
                                              >
                                                {r?.description}
                                              </td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  gap: "10px",
                                                  height: "45px",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <img
                                                  alt=""
                                                  src={edit}
                                                  onClick={() => {
                                                    if (
                                                      !checkboxClicked.includes(
                                                        report.userId,
                                                      )
                                                    ) {
                                                      editTask(
                                                        r,
                                                        report.userId,
                                                      );
                                                    }
                                                    setTypeInScreen("");
                                                  }}
                                                />
                                                <img
                                                  src={trash}
                                                  onClick={() => {
                                                    if (
                                                      !checkboxClicked.includes(
                                                        report.userId,
                                                      )
                                                    ) {
                                                      deleteTask(r);
                                                    }
                                                  }}
                                                />
                                              </td>
                                            </tr>
                                          </>
                                        ))}
                                  </React.Fragment>
                                ))}
                            </tbody>
                          </table>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                </div>
              </>
            )}
            {/* Report mobile view start */}
            {screenSize === "xs" && (
              <section>
                {/* mobile header start */}
                <div className="worktime-nav-tab gap-3 justify-content-end">
                  <img src={Group} alt="" />

                  <h6 style={{ margin: "0", fontSize: "14px" }}>
                    {/* {report.length == 0 ? initialSD : report[0]?.weekStartDate}{" "}
                    | {report.length == 0 ? initialED : report[0]?.weekEndDate} */}
                    {/* mobile view calendar */}
                    {report.length == 0
                      ? moment(startDate).format("DD-MM-YYYY")
                      : report[0]?.weekStartDate}{" "}
                    |{" "}
                    {report.length == 0
                      ? moment(endDate).format("DD-MM-YYYY")
                      : report[0]?.weekEndDate}
                  </h6>
                  <div>
                    <label
                      id="contact_calender"
                      style={{
                        display: "flex",
                        width: "94%",
                      }}
                    >
                      <img
                        style={{ cursor: "pointer" }}
                        src={Calender}
                        alt=""
                        onClick={() => setCalendarIsOpen(!calendarIsOpen)}
                      />
                      <AppDatePicker
                        showInput={false}
                        selected={date}
                        onChange={datePickerFunc}
                        dateFormat="dd/MM/yyyy"
                        onSelect={(d, event) => event.preventDefault()}
                        open={calendarIsOpen}
                        placeholderText={"00/00/0000"}
                      />
                    </label>
                  </div>
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      margin: "0",
                    }}
                  >
                    {t("WEEK ")} {moment(date).week()}
                    {/* {report.length == 0 ? week : report[0]?.weekNo} */}
                  </h3>
                </div>
                {/* mobile header end */}
                <div className="mobile-worktime-table-div">
                  <table className="table">
                    <thead>
                      <tr className="tableHeading">
                        <th className="">
                          {/* Co-worker */}
                          {t("Co-Workers")}
                        </th>
                        <th className=""></th>
                        <th className="">
                          {/* Totals */}
                          {t("Totals")}
                        </th>
                        <th className="text-center">
                          {/* Approve All */}
                          {t("Approve All")}
                        </th>
                      </tr>
                    </thead>

                    <tbody className="tabLine">
                      {filteredReport?.map((report, index) => {
                        return (
                          <>
                            <tr
                              className="trHover"
                              onClick={() => {
                                setMiniBoxOpen(
                                  miniBoxOpen === report.userId
                                    ? null
                                    : report.userId,
                                );
                              }}
                            >
                              <td>
                                {report.firstName} {report.lastName}
                              </td>
                              <td>
                                <img
                                  src={clock}
                                  className="clockIconReport"
                                  alt=""
                                />
                              </td>
                              <td>{getTotalHours(report)}</td>
                              <td>
                                <Checkbox
                                  {...label}
                                  checked={checkboxClicked.includes(
                                    report.userId,
                                  )}
                                  icon={<CircleOutlinedIcon fontSize="small" />}
                                  checkedIcon={<CircleIcon fontSize="small" />}
                                  onChange={(event) => {
                                    event.stopPropagation();
                                    handleCheck(report.userId);
                                  }}
                                  onClick={(event) => event.stopPropagation()}
                                />
                              </td>
                              <td>
                                <img
                                  src={ArrowIcon}
                                  className={
                                    miniBoxOpen === report.userId
                                      ? "arrowIconOpen"
                                      : "arrowIconClose"
                                  }
                                  alt=""
                                  onClick={() => {
                                    setMiniBoxOpen(
                                      miniBoxOpen === report.userId
                                        ? null
                                        : report.userId,
                                    );
                                  }}
                                />
                              </td>
                            </tr>
                            {miniBoxOpen === report.userId && (
                              <>
                                {report?.dateWiseTasksList
                                  ?.sort(
                                    (a, b) =>
                                      new Date(a[0]?.trackerStartDate) -
                                      new Date(b[0]?.trackerStartDate),
                                  )
                                  .map((row, index) => (
                                    <React.Fragment key={index}>
                                      <tr
                                        key={index}
                                        onClick={() =>
                                          handleRowClick(
                                            row[0]?.trackerStartDate,
                                            report?.userId,
                                          )
                                        }
                                        className={
                                          innerRow.includes(
                                            row[0]?.trackerStartDate,
                                          )
                                            ? "expanded-row"
                                            : "table-row-data-div"
                                        }
                                      >
                                        <td className="w-50">
                                          {getDayInitials(
                                            row[0]?.trackerStartDate,
                                          )}
                                          &nbsp; &nbsp;
                                          <span className="fw-bold">
                                            {row[0]?.trackerStartDate}
                                          </span>
                                        </td>

                                        <td></td>

                                        <td style={{ fontWeight: "bold" }}>
                                          {getTotalWorkHrs(row)}
                                        </td>

                                        <td className="ps-3">
                                          {checkboxClicked.includes(
                                            report?.userId,
                                          ) && <img src={lock} alt="locked" />}
                                        </td>
                                      </tr>
                                      {/* {innerRow.includes(
                                        row[0]?.trackerStartDate
                                      ) &&
                                        row
                                          ?.filter(
                                            (item) =>
                                              item.type
                                                ?.toLowerCase()
                                                .includes(query) ||
                                              item.projectName
                                                ?.toLowerCase()
                                                .includes(query) ||
                                              item.taskName
                                                ?.toLowerCase()
                                                .includes(query)
                                          )
                                          .map((r) => (
                                            <>
                                              <tr className="expanded-content-row">
                                                <td
                                                  style={{ border: "none" }}
                                                ></td>
                                                <td>{r?.type}</td>
                                                <td>{r?.projectName}</td>
                                                <td>{r?.taskName}</td>
                                                <td
                                                  style={{ fontWeight: "bold" }}
                                                >
                                                  {getHours(r?.totalHours)}
                                                </td>
                                                <td
                                                  style={{
                                                    maxWidth: "100px",
                                                    textWrap: "wrap",
                                                    wordWrap: "break-word",
                                                  }}
                                                >
                                                  {r?.description}
                                                </td>
                                                <td
                                                  style={{
                                                    display: "flex",
                                                    gap: "10px",
                                                    height: "45px",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <img
                                                    alt=""
                                                    src={edit}
                                                    onClick={() => {
                                                      if (
                                                        !checkboxClicked.includes(
                                                          report.userId
                                                        )
                                                      ) {
                                                        editTask(
                                                          r,
                                                          report.userId
                                                        );
                                                      }
                                                      setTypeInScreen("");
                                                    }}
                                                  />
                                                  <img
                                                    src={trash}
                                                    alt=""
                                                    onClick={() => {
                                                      if (
                                                        !checkboxClicked.includes(
                                                          report.userId
                                                        )
                                                      ) {
                                                        deleteTask(r);
                                                      }
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            </>
                                          ))} */}
                                    </React.Fragment>
                                  ))}
                              </>
                            )}
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </section>
            )}
            {/* Report mobile view end */}
            <div className="px-4 ps-5">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <WorkTimeModal
          showModal={showModal}
          handleCancelModal={handleCancelModal}
          projectTaskTrackingTimeid={
            showEditModalData?.projectTaskTrackingTimeid
          }
          editData={showEditModalData}
          userID={userIDToAdd}
          typeInScreen={typeInScreen}
          setTypeInScreen={setTypeInScreen}
          setCancelPopupShow={setCancelPopupShow}
          setShowModal={setShowModal}
          fetchTaskWithoutProjectRes={fetchTaskWithoutProjectRes}
        />
      )}
    </>
  );
}

const WorkTimeModal = ({
  showModal,
  handleCancelModal,
  projectTaskTrackingTimeid = "",
  editData,
  handleFetch,
  userID,
  typeInScreen,
  setTypeInScreen,
  setShowModal,
  setCancelPopupShow,
  fetchTaskWithoutProjectRes,
}) => {
  const isEdit =
    projectTaskTrackingTimeid && projectTaskTrackingTimeid?.trim() !== "";
  const [showTypeDrop, setShowTypeDrop] = useState(false);
  const [activeProjectDrop, setActiveProjectDrop] = useState(false);
  const [activeTaskDrop, setActiveTaskDrop] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");
  const [taskSearch, setTaskSearch] = useState("");
  const [description, setDescription] = useState("");
  const [day, setDay] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const screenSize = useScreenSize();

  const dispatch = useDispatch();
  const companyId = window.localStorage.getItem("companyid");
  const fetchProject = useSelector((state) => state.user.fetchProject);
  const fetchProjectTasks = useSelector(
    (state) => state.user.fetchProjectTasks,
  );
  const [fromHour, setFromHour] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [total, setTotal] = useState("00:00");
  const [fromMinute, setFromMinute] = useState("");
  const [toHour, setToHour] = useState("");
  const [toMinute, setToMinute] = useState("");
  const [totalMinute, setTotalMinute] = useState("00");
  const [totalHour, setTotalHour] = useState("00");
  const [data, setData] = useState({ type: "Work" });
  useEffect(() => {
    if (editData && editData?.trackerStartDate) {
      const from = editData?.trackerStartTime?.split(":");
      const to = editData?.trackerEndTime?.split(":");
      const [day, month, year] = editData?.trackerStartDate?.split("/");
      const dateObject = new Date(`${year}-${month}-${day}`);
      setDay(dateObject);
      setData({
        taskname: editData?.taskname,
        projectName: editData?.projectname,
        description: editData?.description,
        type: editData?.type || "",
      });
      setFromHour(from?.[0] || "00");
      setFromMinute(from?.[1] || "00");
      setToHour(to?.[0] || "00");
      setToMinute(to?.[1] || "00");
      setFrom((from?.[0] || "00") + ":" + (from?.[1] || "00"));
      setTo((to?.[0] || "00") + ":" + (to?.[1] || "00"));
      setDescription(editData?.description || "");
    }
  }, [editData]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Worktime-Report").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (!editData) {
      setFromMinute("00");
    }
  }, [fromHour]);
  useEffect(() => {
    if (!editData) {
      setToMinute("00");
    }
  }, [toHour]);

  useEffect(() => {
    const handleSearch = () => {
      const filteredProjects =
        fetchProject?.data[0]?.projectstatus?.[0]?.projectdetails?.filter(
          (project) =>
            project?.projectname
              ?.toLowerCase()
              ?.includes(projectSearch?.toLowerCase()),
        );
      const filteredTasks = fetchProjectTasks?.data?.filter((task) =>
        task?.taskname?.toLowerCase()?.includes(taskSearch?.toLowerCase()),
      );
      setProjects(filteredProjects);
      setTasks(filteredTasks);
    };
    if (projectSearch.trim() !== "" || taskSearch.trim() !== "") {
      handleSearch();
    } else {
      if (projectSearch.trim() === "") {
        if (fetchProjectTasks?.status === true) {
          setTasks(fetchProjectTasks?.data);
        }
      }
      if (taskSearch.trim() === "") {
        if (fetchProjectTasks?.status === true) {
          setTasks(fetchProjectTasks?.data);
        }
      }
    }
  }, [projectSearch, taskSearch]);
  const calculateTotalTimes = (hour, minute) => {
    return parseInt(hour, 10) * 60 + parseInt(minute, 10);
  };

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time.toString();
  };

  const calculateAndSetTotal = () => {
    const fromTime = calculateTotalTimes(fromHour || "00", fromMinute || "00");
    const toTime = calculateTotalTimes(toHour || "00", toMinute || "00");

    if (toTime >= fromTime) {
      const totalTimeInMinutes = toTime - fromTime;
      const totalHours = Math.floor(totalTimeInMinutes / 60);
      const totalMinutes = totalTimeInMinutes % 60;

      const formattedHours = formatTime(totalHours);
      const formattedMinutes = formatTime(totalMinutes);

      setTotal(`${formattedHours}:${formattedMinutes}`);
      setTotalHour(formattedHours);
      setTotalMinute(formattedMinutes);
    } else {
      setTotalHour("00");
      setTotalMinute("00");
    }
  };
  const calculateTotalTime = () => {
    if (screenSize === "xs") {
      const fromTime =
        parseInt(fromHour || "00", 10) * 60 + parseInt(fromMinute || "00", 10);
      const toTime =
        parseInt(toHour || "00", 10) * 60 + parseInt(toMinute || "00", 10);
      if (toTime >= fromTime) {
        const totalTimeInMinutes = toTime - fromTime;
        const totalHours = Math.floor(totalTimeInMinutes / 60);
        const totalMinutes = totalTimeInMinutes % 60;
        const formattedHours =
          totalHours < 10 ? `0${totalHours}` : totalHours.toString();
        const formattedMinutes =
          totalMinutes < 10 ? `0${totalMinutes}` : totalMinutes.toString();
        setTotalHour(formattedHours);
        setTotalMinute(formattedMinutes);
      } else {
        setTotalHour("00");
        setTotalMinute("00");
      }
    } else {
      calculateAndSetTotal();
    }
  };

  const validate = () => {
    if (!data?.taskname || data?.taskname?.trim() === "") {
      setIsSubmitDisabled(true);
      return;
    }
    if (!data?.type || data?.type?.trim() === "") {
      setIsSubmitDisabled(true);
      return;
    }
    if (screenSize === "xs" && totalHour === "00" && totalMinute === "00") {
      setIsSubmitDisabled(true);
      return;
    }
    if (
      screenSize !== "xs" &&
      total?.split(":")?.[0] === "00" &&
      total?.split(":")?.[1] === "00"
    ) {
      setIsSubmitDisabled(true);
      return;
    }
    if (
      screenSize !== "xs" &&
      (total?.split(":")?.[0] === undefined ||
        total?.split(":")?.[1] === undefined)
    ) {
      setIsSubmitDisabled(true);
      return;
    }
    setIsSubmitDisabled(false);
  };
  useEffect(() => {
    validate();
  }, [totalHour, totalMinute, data, total]);

  useEffect(() => {
    calculateTotalTime();
  }, [fromHour, fromMinute, toHour, toMinute, from, to]);

  useEffect(() => {
    dispatch(FetchProject(companyId));
  }, [companyId]);

  useEffect(() => {
    if (data?.projectId && data?.projectId?.trim() !== "") {
      dispatch(fetchTaskByProject(data?.projectId));
    }
  }, [data?.projectId]);

  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    // if (fetchProject?.status === true) {
    //   setProjects(fetchProject?.data[0]?.projectstatus?.[0]?.projectdetails);
    // }

    if (fetchProject?.status === true) {
      const projectDetails = fetchProject.data[0]?.projectstatus
        .map((item) => item.projectdetails)
        .flat();
      setProjects(projectDetails);
    }
  }, [fetchProject]);

  useEffect(() => {
    if (fetchProjectTasks?.status === true) {
      setTasks(fetchProjectTasks?.data);
    }
  }, [fetchProjectTasks]);

  const [conflict, setConflict] = useState({
    isConflict: false,
    conflictMessage: "",
  });
  const handleAddManualTime = async () => {
    const dateObj = new Date(day);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const date = dateObj.getDate().toString().padStart(2, "0");
    const formattedDate = `${date}/${month}/${year}`;

    // let from_submit = fromHour + ":" + fromMinute + ":00";
    let from_submit = `${fromHour}${fromMinute ? ":" + fromMinute : ":00"}:00`;
    let to_submit = `${toHour}${toMinute ? ":" + toMinute : ":00"}:00`;
    // let to_submit = toHour + ":" + toMinute + ":00";

    const hourInt = parseInt(totalHour, 10);

    const minuteInt = parseInt(totalMinute, 10);

    let totalTime = hourInt + minuteInt / 60;
    // if (screenSize === "xs") {
    //   from_submit = from + ":00"
    //   to_submit = to + ":00"
    //   totalTime = parseInt(total?.split(":")?.[0]) + parseInt(total?.split(":")?.[1]) / 60;
    // }
    const formattedTime = totalTime?.toFixed(2);

    const craftedData = {
      projectId: data?.projectId ? data?.projectId : null,
      taskid: data?.taskid,
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      TotalTrackedTime: formattedTime,
      type: data?.type || "Work",
      description: description,
      isManual: 0,
      userid: userID,
    };
    const craftedDataForEdit = {
      projectTaskTrackingTimeid: projectTaskTrackingTimeid || "",
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      TotalTrackedTime: formattedTime,
      type: data?.type || "Work",
      description: description,
    };
    setLoading(true);
    await CheckExistingTimeSession({
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      userid: userID,
    }).then((data) => {
      setConflict({
        isConflict: !data?.data?.status,
        conflictMessage: data?.data?.message || "",
      });
      if (data?.data?.status) {
        if (isEdit) {
          UpdateManualTimeSession(craftedDataForEdit)
            .then(() => {
              setLoading(false);
              setShowModal(false);
              handleCancelModal();
              handleFetch();
            })
            .catch(() => {
              setLoading(false);
            });
        } else {
          CreateManualTimeSession(craftedData)
            .then(() => {
              setLoading(false);
              setShowModal(false);
              handleCancelModal();
              handleFetch();
            })
            .catch(() => {
              setLoading(false);
            });
        }
      } else {
        setLoading(false);
      }
    });
  };

  const updateTimeSessionHardCore = () => {
    const dateObj = new Date(day);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const date = dateObj.getDate().toString().padStart(2, "0");
    const formattedDate = `${date}/${month}/${year}`;

    // let from_submit = fromHour + ":" + fromMinute + ":00";
    let from_submit = `${fromHour}${fromMinute ? ":" + fromMinute : ":00"}:00`;
    let to_submit = `${toHour}${toMinute ? ":" + toMinute : ":00"}:00`;
    // let to_submit = toHour + ":" + toMinute + ":00";

    const hourInt = parseInt(totalHour, 10);

    const minuteInt = parseInt(totalMinute, 10);

    let totalTime = hourInt + minuteInt / 60;
    // if (screenSize === "xs") {
    //   from_submit = from + ":00"
    //   to_submit = to + ":00"
    //   totalTime = parseInt(total?.split(":")?.[0]) + parseInt(total?.split(":")?.[1]) / 60;
    // }
    const formattedTime = totalTime?.toFixed(2);

    const craftedDataForEdit = {
      projectTaskTrackingTimeid: projectTaskTrackingTimeid || "",
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      TotalTrackedTime: formattedTime,
      type: data?.type || "Work",
      description: description,
    };

    UpdateManualTimeSession(craftedDataForEdit)
      .then(() => {
        setLoading(false);
        setShowModal(false);
        handleCancelModal();
        handleFetch();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const [dateError, setDateError] = useState(false);

  // asc fetchTaskWithoutProject res start.
  useEffect(() => {
    dispatch(FetchTasksWithOutProject(companyId));
  }, []);

  const [taskWithoutProjectData, setTaskWithoutProjectData] = useState([]);
  useEffect(() => {
    if (fetchTaskWithoutProjectRes.status === true) {
      // setTaskWithoutProjectData(fetchTaskWithoutProjectRes.data);
      setTasks(fetchTaskWithoutProjectRes.data);
    }
  }, [fetchTaskWithoutProjectRes]);
  // asc fetchTaskWithoutProject res end.

  return (
    <>
      <div className="wt-modal-background">
        <div className="wt-mdoal-div">
          <section className="wt-modal-top-sec">
            <p className="wt-modal-top-text">
              {isEdit ? "Edit" : "Add"}
              {/* Time */}
              {t("Time")}
            </p>
          </section>
          <section className="wt-modal-bottom-sec">
            <p className="wt-modal-light-text">
              {/* TYPE */}
              {t("TYPE")}
            </p>
            <article className="wt-modal-work-flex frc">
              <p
                className="wt-space-content-text"
                style={{ flexGrow: "1" }}
                onClick={() => {
                  setShowTypeDrop(!showTypeDrop);
                  setActiveProjectDrop(false);
                  setActiveTaskDrop(false);
                }}
              >
                {data?.type?.trim() === "" || !data?.type
                  ? isEdit
                    ? data?.type || ""
                    : "Work"
                  : data.type}
              </p>
              <img
                alt=""
                src={Cross}
                style={{ width: "8px", height: "8px", flexShrink: "0" }}
                onClick={() => {
                  setShowTypeDrop(!showTypeDrop);
                  setActiveProjectDrop(false);
                  setActiveTaskDrop(false);
                }}
              />
              {showTypeDrop && (
                <article className="wt-modal-work-drop fc">
                  <img
                    alt=""
                    src={Downarrow}
                    className="wt-modal-down-btn"
                    onClick={() => setShowTypeDrop(false)}
                  />
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type?.trim() === "" || !data?.type
                        ? ""
                        : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Work" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Work */}
                    {t("Work")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Sick" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Sick" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Sick */}
                    {t("Sick")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Holiday" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Holiday" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Holiday */}
                    {t("Holiday")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Vacation" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Vacation" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Vacation */}
                    {t("Vacations")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Other" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Other" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Other */}
                    {t("Other")}
                  </p>
                </article>
              )}
            </article>
          </section>
          <div className="wt-modal-bottom-sec" style={{ position: "relative" }}>
            <p className="wt-modal-light-text">
              {/* project */}
              {t("PROJECT")}
            </p>
            <p
              className="wt-space-content-text"
              style={{
                flexGrow: "1",
                cursor: "pointer",
                opacity: activeProjectDrop ? "60%" : "1",
              }}
              onClick={() => {
                const fg = activeProjectDrop;
                setShowTypeDrop(false);
                setActiveProjectDrop(!fg);
                setActiveTaskDrop(false);
              }}
            >
              {/* {data?.projectName || "Select a Project"} */}
              {data?.projectName || t("Select a Project")}
            </p>
            {activeProjectDrop && (
              <section
                className={
                  screenSize === "xs"
                    ? "wt-modal-project-drop-mobile"
                    : "wt-modal-project-drop px-0"
                }
              >
                <section className="wt-modal-search ms-3">
                  <img
                    src={searchicon}
                    alt="Search Icon"
                    style={{ flexShrink: "0", width: "17px", height: "17px" }}
                  />
                  <input
                    className="quote-modal-input w-100"
                    // placeholder="Search..."
                    placeholder={t("Search")}
                    value={projectSearch}
                    onChange={(e) => setProjectSearch(e.target.value)}
                  />
                </section>
                <section className="wt-modal-list gap-0">
                  {projects?.map((project) => {
                    return (
                      <p
                        className="choose-project ulterDrop"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          let dataAltered = data;
                          if (project?.projectid !== data?.projectId) {
                            delete dataAltered.taskid;
                            delete dataAltered.taskname;
                          }
                          setData({
                            ...dataAltered,
                            projectId: project?.projectid || "",
                            projectName: project?.projectname || "",
                          });
                          setActiveProjectDrop(false);
                          setTypeInScreen("asc");
                        }}
                      >
                        {project?.projectname || ""}
                      </p>
                    );
                  })}
                </section>
              </section>
            )}
          </div>
          <div className="wt-modal-bottom-sec" style={{ position: "relative" }}>
            <p className="wt-modal-light-text">
              {/* task */}
              {t("TASK")}
            </p>
            <p
              className="wt-space-content-text"
              style={{
                flexGrow: "1",
                cursor: "pointer",
                opacity: activeTaskDrop ? "60%" : "1",
              }}
              onClick={() => {
                const fg = activeTaskDrop;
                setShowTypeDrop(false);
                setActiveProjectDrop(false);
                setActiveTaskDrop(!fg);
              }}
            >
              {/* {data?.taskname || "Select a Task"} */}
              {data?.taskname || t("Select A task")}
            </p>
            {activeTaskDrop && (
              <section
                className={
                  screenSize === "xs"
                    ? "wt-modal-project-drop-mobile"
                    : "wt-modal-project-drop px-0"
                }
              >
                <section className="wt-modal-search m-3">
                  <img
                    src={searchicon}
                    alt="Search Icon"
                    style={{ flexShrink: "0", width: "17px", height: "17px" }}
                  />
                  <input
                    className="quote-modal-input w-100"
                    placeholder="Search..."
                    value={taskSearch}
                    onChange={(e) => setTaskSearch(e.target.value)}
                  />
                </section>
                <section className="wt-modal-list gap-0">
                  {tasks?.map((task) => {
                    return (
                      <p
                        className="choose-project ulterDrop"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setData({
                            ...data,
                            taskid: task?.taskid || "",
                            taskname: task?.taskname,
                          });
                          setActiveTaskDrop(false);
                          setTypeInScreen("asc");
                        }}
                      >
                        {task?.taskname || ""}
                      </p>
                    );
                  })}
                </section>
              </section>
            )}
          </div>
          {screenSize === "xs" ? (
            <div
              className="wt-modal-bottom-sec pe-1"
              style={{ position: "relative" }}
            >
              <p className="wt-modal-light-text">
                {/* time span */}
                {t("time span")}
              </p>
              <section className="frc wt-modal-time gap-1">
                <article className="frc" style={{ gap: "7.5px" }}>
                  <img
                    alt=""
                    src={Calendar2}
                    style={{ width: "21px", height: "22px" }}
                  />
                  {/* <p className="wt-modal-cal-text">25.04.2023</p> */}
                  <AppDatePicker
                    selected={day}
                    isDisabledForFuture={true}
                    onChange={setDay}
                    dateFormat="dd/MM/yyyy"
                    onSelect={(d, event) => event.preventDefault()}
                    placeholderText={"00/00/0000"}
                  />
                </article>
                <div style={{ width: "70%" }}>
                  <article className="frc" style={{ gap: "5px" }}>
                    <img
                      alt=""
                      src={Clock}
                      style={{ width: "15px", height: "15px" }}
                    />
                    <p className="wt-modal-light-text">
                      {/* from */}
                      {t("From")}
                    </p>
                    <div className="frc">
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={fromHour}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 23
                          ) {
                            setFromHour(inputValue);
                          } else {
                            setFromHour("00");
                          }
                        }}
                      />
                      <p className="wt-modal-light-text">:</p>
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={fromMinute}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 59
                          ) {
                            setFromMinute(inputValue);
                          } else {
                            setFromMinute("00");
                          }
                        }}
                      />
                    </div>

                    <p className="wt-modal-light-text">to</p>
                    <div className="frc">
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={toHour}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 23
                          ) {
                            setToHour(inputValue);
                          } else {
                            setToHour("00");
                          }
                        }}
                      />
                      <p className="wt-modal-light-text">:</p>
                      {/*  const disabled = handleCheckHours(i) */}
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={toMinute}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 59
                          ) {
                            setToMinute(inputValue);
                          } else {
                            setToMinute("00");
                          }
                        }}
                      />
                    </div>
                  </article>

                  <article className="frc" style={{ gap: "10px" }}>
                    <img
                      alt=""
                      src={Clock}
                      style={{ width: "17px", height: "17px" }}
                    />
                    <p className="wt-modal-light-text">
                      {/* total */}
                      {t("TOTAL")}
                    </p>
                    <div className="frc">
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={totalHour}
                      />
                      <p className="wt-modal-light-text">:</p>
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={totalMinute}
                      />
                    </div>
                  </article>
                </div>
              </section>
            </div>
          ) : (
            <div
              className="wt-modal-bottom-sec pe-1"
              style={{ position: "relative" }}
            >
              <p className="wt-modal-light-text">
                {/* time span */}
                {t("time span")}
              </p>
              <section className="frc wt-modal-time gap-1">
                <article
                  className="frc"
                  style={{ gap: "5px", minWidth: "107px" }}
                >
                  <img
                    alt=""
                    src={Calendar2}
                    style={{ width: "21px", height: "22px" }}
                  />
                  {/* <p className="wt-modal-cal-text">25.04.2023</p> */}
                  <AppDatePicker
                    selected={day}
                    isDisabledForFuture={true}
                    onChange={setDay}
                    dateFormat="dd/MM/yyyy"
                    onSelect={(d, event) => event.preventDefault()}
                    placeholderText={"00/00/0000"}
                    isError={dateError}
                    error={setDateError}
                  />
                </article>

                <article className="frc" style={{ gap: "5px" }}>
                  <img
                    alt=""
                    src={Clock}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <p className="wt-modal-light-text">from</p>
                  <div className="frc" style={{ minWidth: "60px" }}>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      value={fromHour}
                      maxLength="2"
                      id="hoursInput"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 23
                        ) {
                          setFromHour(value || "00");
                          if (value.length === 2) {
                            document.getElementById("minutesInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setFromHour((prevHours) =>
                            prevHours.slice(0, prevHours.length - 1),
                          );
                        }
                      }}
                    />
                    <p className="wt-modal-light-text">:</p>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      id="minutesInput"
                      maxLength="2"
                      value={fromMinute}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 59
                        ) {
                          setFromMinute(value || "00");
                          if (value.length === 0 && fromHour.length > 0) {
                            document.getElementById("hoursInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setFromMinute((prevMinutes) =>
                            prevMinutes.slice(0, prevMinutes.length - 1),
                          );
                        }
                      }}
                    />
                  </div>

                  <p className="wt-modal-light-text">to</p>
                  <div className="frc" style={{ minWidth: "60px" }}>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      value={toHour}
                      maxLength="2"
                      id="hoursToInput"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 23
                        ) {
                          setToHour(value || "00");
                          if (value.length === 2) {
                            document.getElementById("minutesToInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setToHour((prevHours) =>
                            prevHours.slice(0, prevHours.length - 1),
                          );
                        }
                      }}
                    />
                    <p className="wt-modal-light-text">:</p>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      id="minutesToInput"
                      maxLength="2"
                      value={toMinute}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 59
                        ) {
                          setToMinute(value || "00");
                          if (value.length === 0 && toHour.length > 0) {
                            document.getElementById("hoursToInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setToMinute((prevMinutes) =>
                            prevMinutes.slice(0, prevMinutes.length - 1),
                          );
                        }
                      }}
                    />
                  </div>
                </article>

                <article className="frc" style={{ gap: "5px" }}>
                  <img
                    alt=""
                    src={Clock}
                    style={{ width: "17px", height: "17px" }}
                  />
                  <p className="wt-modal-light-text">
                    {/* total */}
                    {t("TOTAL")}
                  </p>
                  <div className="frc" style={{ minWidth: "60px" }}>
                    <input
                      style={{ width: "100%" }}
                      className="wt-modal-time-input total-color"
                      placeholder="00:00"
                      value={total}
                    />
                  </div>
                </article>
              </section>
            </div>
          )}
          <section className="wt-modal-bottom-sec"></section>
          <section className="wt-modal-bottom-sec">
            <p className="wt-modal-light-text">
              {/* description */}
              {t("DESCRIPTION")}
            </p>
            <textarea
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setTypeInScreen("asc");
              }}
              // placeholder="A brief description of the task you performed"
              placeholder={t("A brief description of the task you performed")}
              className="wt-modal-description"
            />
          </section>
          {screenSize === "xs" ? (
            <section className="wt-modal-btns">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: "5px",
                  marginLeft: "20px",
                }}
              >
                <button
                  type="button"
                  className="addProCancel wt-cancel-btn"
                  style={{ width: "100%", height: "50px" }}
                  onClick={handleCancelModal}
                  // onClick={() => {
                  //   if (typeInScreen !== "") {
                  //     setCancelPopupShow(true);
                  //   } else {
                  //     setShowModal(false);
                  //   }
                  //   handleCancelModal()
                  // }}
                >
                  {/* Cancel */}
                  {t("Cancel")}
                </button>
                <button
                  disabled={isSubmitDisabled}
                  style={{
                    width: "100%",
                    height: "50px",
                    cursor: isSubmitDisabled ? "not-allowed" : "pointer",
                  }}
                  type="button"
                  onClick={handleAddManualTime}
                  className="wt-add-btn"
                >
                  {loading ? (
                    <div className="gap-1 d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      ></div>
                      <span>{isEdit ? "Updating..." : "Adding..."}</span>
                    </div>
                  ) : isEdit ? (
                    t("Update") // update
                  ) : (
                    t("Add") // add
                  )}
                </button>
              </div>
            </section>
          ) : (
            <section className="wt-modal-btns">
              <p style={{ minWidth: "60px" }}></p>
              <button
                type="button"
                className="addProCancel wt-cancel-btn"
                // onClick={handleCancelModal}
                onClick={() => {
                  if (typeInScreen !== "") {
                    setCancelPopupShow(true);
                  } else {
                    setShowModal(false);
                  }
                  handleCancelModal();
                }}
              >
                {/* Cancel */}
                {t("Cancel")}
              </button>
              <button
                disabled={isSubmitDisabled}
                style={{ cursor: isSubmitDisabled ? "not-allowed" : "pointer" }}
                type="button"
                onClick={handleAddManualTime}
                className="wt-add-btn"
              >
                {loading ? (
                  <div className="gap-1 d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></div>
                    <span>{isEdit ? "Updating..." : "Adding..."}</span>
                  </div>
                ) : isEdit ? (
                  t("Update") // update
                ) : (
                  t("Add") // add
                )}
              </button>
            </section>
          )}
        </div>
      </div>

      <Modal
        show={conflict?.isConflict}
        className="modelwidthWorkTime modal-dialog1"
        style={{
          backgroundColor: "transparent",
          opacity: 1,
        }}
        id="worktime-member-modal"
        centered
      >
        <Modal.Body style={{ backgroundColor: "#D2DCE9" }}>
          <div className="flex_class my-5">
            <img
              src={Cross}
              alt=""
              width={12}
              className="d-flex justify-content-end my-3 ms-auto pointer"
              onClick={() => {
                setConflict({ isConflict: false, conflictMessage: "" });
              }}
            />
            <div style={{ color: "#1A3A79", fontWeight: "bold" }}>
              {/* The time span overlaps existing time tracked. */}
              {t("The time span overlaps existing time tracked.")}
            </div>

            <div className="">
              {/* Please introduce a new time span. */}
              {t("Please introduce a new time span.")}
            </div>

            <div className="mt-5 ">
              <button
                className="ms-2 w-25 btn-yes"
                onClick={() => {
                  updateTimeSessionHardCore();
                  setConflict({ isConflict: false, conflictMessage: "" });
                }}
              >
                {/* Ok */}
                {t("Ok")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
